import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import UPDATE_SESSION from '../mutations/UPDATE_SESSION';

const useUpdateSession = () => {
    const [ patchSession ] = useMutation( UPDATE_SESSION );

    const updateSession = async ( saveData ) => {
        try {
            const response = await patchSession( { variables: { input: saveData } } );
            const success = response?.data?.patchSession?.id;
            
            if ( success ) {
                return {
                    success: true,
                    response: response?.data?.patchSession
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error saving session', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            updateSession
        };
    }, [] );
};

export default useUpdateSession;
